import { CircularProgress } from "@flat-ui";
import { Box } from "@mui-wrapper";

/** Component to show while the email is being verified */
export function VerifyingEmail(): JSX.Element {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box component="div">
        <CircularProgress sx={{ mr: "10px" }} size="24px" thickness={5} />
      </Box>

      <Box component="div">Verifying email address...</Box>
    </Box>
  );
}
